/// <amd-module name="VSSUI/MessageBar" />
export { MessageBar } from "./Components/MessageBar/MessageBar";
export { MessageBarSeverity, IMessageBarProps } from "./Components/MessageBar/MessageBar.Props";